const listeners = new Set();

// Relais des évènements du moteur vers l'interface ; on peut s'abonner avant le démarrage du moteur
export const subscribeSyncEvents = (listener) => {
    listeners.add(listener);
    return () => listeners.delete(listener);
};

// Transmet un évènement à tous les abonnés
export const emitSyncEvent = (event) => listeners.forEach(listener => {
    try { listener(event); }
    catch (error) { console.error(error); }
});
